import { useAuth } from "@/core/auth/hooks/useAuth";
import { useCurrentBusiness } from "@/features/business/hooks/useCurrentBusiness";
import { Button } from "@/shared/components/shadcn/Button";
import { FullScreenDialog } from "@/shared/components/ui/FullScreenDialog";
import { useFormsReturnRefresh } from "../hooks/formQueries";
import { useFormPreviewOverlay } from "../hooks/useFormPreviewOverlay";
import { FormPreviewContent } from "./FormPreviewContent";

export function FormPreviewOverlay() {
  const { user } = useAuth();
  const { businessId } = useCurrentBusiness();
  const { formId, appointmentId, expectedVersionId, closePreview } = useFormPreviewOverlay();
  useFormsReturnRefresh();
  if (!formId || !user || !businessId) return null;
  return (
    <FullScreenDialog title="Form preview" onClose={closePreview}
      footer={<Button type="button" variant="outline" onClick={() => closePreview()}>Close preview</Button>}>
      <div className="space-y-6 px-4 py-4 sm:px-[30px]">
        <FormPreviewContent key={`${user.id}:${businessId}:${appointmentId ?? "live"}:${formId}:${expectedVersionId ?? ""}`}
          formId={formId} appointmentId={appointmentId} expectedVersionId={expectedVersionId} />
      </div>
    </FullScreenDialog>
  );
}
